export default __webpack_public_path__ + "static/media/1_1_hl.195cb58d.png";